import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api, setToken } from '../lib/api.js'

export function Login() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  async function onSubmit(e) {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      const res = await api('/auth/login', { method: 'POST', body: { email, password }, auth: false })
      if (res.user.role !== 'admin' && res.user.role !== 'staff') {
        throw new Error('Bu panele erisim yetkiniz yok')
      }
      setToken(res.access_token)
      navigate('/', { replace: true })
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-wrap">
      <form className="card login-card" onSubmit={onSubmit}>
        <h1>GrowingChild Admin</h1>
        {error && <div className="alert">{error}</div>}
        <label>
          E-posta
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
          />
        </label>
        <label>
          Sifre
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>
        <button className="btn" disabled={loading}>
          {loading ? 'Giris yapiliyor...' : 'Giris yap'}
        </button>
      </form>
    </div>
  )
}
